module.exports = __webpack_public_path__ + "img/placeholder-happy.09200675.png";